import { useStyles } from "Styles";
import { Link, useHistory, Link as DomLink, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
import * as React from "react";
import { useMsg } from ".././hooks/MsgProvider";
import axios from "../CustomAxios";
import { UserContext } from "../hooks/UserContext";
import { success, error, confirmDialog } from "./common/Constants";
import { DateWithTime } from "components/common/HadclFormatter";
import useInformation from "../hooks/useInformation";
import { useDirtyCheck } from "hooks/DirtyCheckProvider";
import useSysParam from "hooks/UseSysParam";
import useNavFixed from "hooks/useNavFixed";
import HomeLayoutPC from "view/pc/layout/HomeLayout.pc";
import HomeLayoutMobile from "view/mobile/layout/HomeLayout.mobile";
import RenderPcOrMobile from "./RenderPcOrMobile";
import ConfirmDialog from "components/common/ConfirmDialog";
import useModal from "hooks/useModal";
import { getNotificationInfo, getUsefulLinks, readNotification, logout } from "api";

export const HomeLayoutViewContext = React.createContext({});
function HomeLayout(props) {
	const classes = useStyles();
	const { setUser, user } = React.useContext(UserContext);
	const showModal = useModal();
	const [sessionExtendOpen, setSessionExtendOpen] = React.useState(false);
	const [timeoutOpen, setTimeoutOpen] = React.useState(false);
	const sessionTimeout = React.useRef();
	const promptTimeoutTimer = React.useRef(null);
	const refreshTokenTimer = React.useRef(null);
	const eventFuncRef = React.useRef(null);
	const countNoActionTimer = React.useRef(Date.now());
	const { setSuccessMsg, setErrMsg } = useMsg();
	const { informations: emails } = useInformation("HADCL_EMAIL");
	const { informations: addresses } = useInformation("HADCL_ADDRESS");
	const [usefulLinks, setUsefulLinks] = React.useState([]);
	const [notifications, setNotifications] = React.useState([]);
	const sitemaps = user?.menus?.siteMaps || [];
	const { isDirty } = useDirtyCheck();
	let history = useHistory();
	const { paramTextValue: logoLink } = useSysParam("sys_logo_hyperlink");
	const { paramTextValue: contactEmail } = useSysParam("hadcl_other_email");

	const location = useLocation();

	const [openQrCode, setOpenQrCode] = React.useState(false);

	const { navRef, isFixed } = useNavFixed();

	const [notificationAnchorEl, setNotificationAnchorEl] = React.useState(null);

	const [onlyOnPCDialog, setOnlyOnPCDialog] = React.useState(false);

	const getUserEmail = () => {
		if (user?.user) {
			const { salutation, firstName, lastName } = user.user;
			return `Hello! ${salutation} ${firstName} ${lastName}`;
		}
		return "Hello!";
	};

	const promptTimeout = () => {
		setSessionExtendOpen(true);
	};

	const promptLogout = () => {
		setTimeoutOpen(true);
	};

	const onSessionExtend = () => {
		setSessionExtendOpen(false);
		onExtendUpdateToken();
	};

	const closeSessionExtend = () => {
		setSessionExtendOpen(false);
	};

	const closeTimeout = () => {
		setTimeoutOpen(false);
	};

	const doLogout = () => {
		showModal((pros) => (
			<ConfirmDialog
				{...pros}
				description={confirmDialog.logout}
				onConfirm={() => {
					goLogout();
				}}
				//onCancel={() => console.log("Deletion cancelled.")}
				okText="Log out"
			/>
		));
	};

	const goLogout = async () => {
		// console.log('doLogout')
		if (!isDirty) {
			const res = await logout({
				accToken: sessionStorage.getItem("accessToken"),
				refreshToken: sessionStorage.getItem("refreshToken"),
			});
			sessionStorage.clear();
			setUser(null);
		}

		history.push("/login");
	};

	const clearTimer = () => {
		const body = document.querySelector("html");
		body.removeEventListener("click", eventFuncRef.current);
		body.removeEventListener("mousemove", eventFuncRef.current);
		body.removeEventListener("mousewheel", eventFuncRef.current);
		body.removeEventListener("keydown", eventFuncRef.current);
		clearInterval(refreshTokenTimer.current);
		clearInterval(promptTimeoutTimer.current);
	};

	const onExtendUpdateToken = async (isAuto) => {
		var checkUserID = user?.user?.id;
		var UserID = checkUserID ? checkUserID : "";
	};

	const timeoutFunc = () => {
		const nowDate = Date.now();
		if (nowDate - countNoActionTimer.current >= sessionTimeout.current) {
			clearTimer();
			promptTimeout();
			sessionStorage.clear();
		}
	};

	const eventFunc = () => {
		clearInterval(promptTimeoutTimer.current);
		countNoActionTimer.current = Date.now();
		promptTimeoutTimer.current = setInterval(() => timeoutFunc(), 1000);
	};

	const startTimeoutTimer = () => {
		const expSecond = getExpTime();
		const autoExtendTokenTime = expSecond / 2;

		const refreshTimeoutFunc = () => {
			onExtendUpdateToken(true);
		};
		refreshTokenTimer.current = setInterval(refreshTimeoutFunc, autoExtendTokenTime);

		promptTimeoutTimer.current = setInterval(() => timeoutFunc(), 1000);
		const body = document.querySelector("html");
		eventFuncRef.current = () => eventFunc();
		body.addEventListener("click", eventFuncRef.current);
		body.addEventListener("mousemove", eventFuncRef.current);
		body.addEventListener("mousewheel", eventFuncRef.current);
		body.addEventListener("keydown", eventFuncRef.current);
	};

	const getExpTime = () => {
		let token = sessionStorage.getItem("token");
		var expSecond = 0;
		if (token) {
			const { exp, expiredTime } = jwtDecode(token);
			sessionTimeout.current = expiredTime * 60 * 1000;
			const secondNow = new Date().getTime();
			expSecond = exp * 1000 - secondNow;
		}
		return expSecond;
	};

	React.useEffect(() => {
		if (user) {
			// startTimeoutTimer();
		}

		// clear on component unmount
		return () => {
			clearTimer();
		};
	}, [user]);

	const handleRefreshTokenInvalid = (event) => {
		const { logout, userId } = event.data;
		const userInfo = JSON.parse(sessionStorage.getItem("DATA_SERVICES_USER") ?? "{}");
		//console.log(userInfo?.user?.id, userId);

		if (logout && userInfo?.user?.id === userId) {
			setTimeoutOpen(true);
		}
	};

	React.useEffect(() => {
		// To handle request error
		const tokenChannel = new BroadcastChannel("tokenChannel");
		tokenChannel.addEventListener("message", handleRefreshTokenInvalid);

		getUsefulLinks().then((res) => {
			setUsefulLinks(res.data);
		});

		return () => {
			clearInterval(refreshTokenTimer.current);
			clearInterval(promptTimeoutTimer.current);
			tokenChannel.removeEventListener("message", handleRefreshTokenInvalid);
			tokenChannel.close();
		};
	}, []);

	const lastLoginTime = (datetime) => {
		const timeTitle = "Last Successful Login";
		return `${timeTitle}: ${datetime === "null" ? "--" : DateWithTime(datetime)}`;
	};
	const goTop = () => {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	};

	const clickMenu = (code) => {
		const mcode = code.slice(3);
		if (
			mcode === "PROGRESS_REPORT" ||
			mcode === "PROGRESS_REPORT_ADM" ||
			mcode === "OUTPUT_REQUEST" ||
			mcode === "OUTPUT_REQUEST_MANAGEMENT" ||
			mcode === "ONLINE_INFO" ||
			mcode === "ONLINE_INFO_MANAGEMENT"
		) {
			setOnlyOnPCDialog(true);
			return;
		}

		if (sessionStorage.getItem("haveOutstandingReport") == "true") {
			return;
		}

		goTop();
		if (code && (code === "TM_ACCESS_QR_CODE" || code === "MM_ACCESS_QR_CODE" || code === "SM_ACCESS_QR_CODE")) {
			setOpenQrCode(true);
		}
	};

	const loadNotifications = async () => {
		try {
			const res = await getNotificationInfo();
			setNotifications(res.data);
		} catch (error) {
			console.log("error", error);
		}
	};

	const clickNotification = (event) => {
		if (notifications.length) {
			setNotificationAnchorEl(event.currentTarget);
			const notificationIds = notifications?.filter((item) => !item.isRead).map((item) => item.id);
			if (notificationIds.length)
				readNotification(notificationIds).catch((err) => {
					console.log(err);
				});
		}
	};

	const handlePinned = (notification) => {
		axios
			.post("/information/set-isPinned", {
				id: notification.id,
				isPinned: !notification.isPinned,
				type: notification.type,
			})
			.then(({ data: result }) => {
				loadNotifications();
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const handleDeleteNotification = (notification) => {
		axios
			.post("/information/delete-notification", { id: notification.id })
			.then(({ data: result }) => {
				loadNotifications();
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const notificationRedirect = (notification) => {
		const isResearcher = user.roles.some((e) => e === "COL_RESEARCHER" || e === "SELF_RESEARCHER");
		switch (notification.type) {
			case "NTF_URGENT_CLOSE":
				if (isResearcher) {
					history.push("/manage-bookings", { date: notification.busDate });
					break;
				} else {
					history.push("/access-management", { isSetup: 1, date: notification.busDate });
					break;
				}
			case "NTF_BOOKING_UPDATED":
				history.push(isResearcher ? "/manage-bookings" : "/access-management", { date: notification.busDate });
				break;
			case "NTF_NOT_SIGNED_OUT":
				history.push("/attendance-management", { date: notification.busDate });
				break;
			case "NTF_LOW_RATE":
				history.push("/manage-bookings", { date: notification.busDate });
				break;
			case "NTF_PROGRESS_BEFORE":
			case "NTF_PROGRESS_REVIEWED":
			case "NTF_PROGRESS_COMMENTS":
			case "NTF_PROGRESS_RETURNED":
				history.push("/progress-reports");
				break;
		}
	};

	const showNtfRedirect = (ntf) => {
		return true;
	};

	const showNtfClose = (ntf) => {
		return (
			ntf.type === "NTF_LOW_RATE" ||
			ntf.type === "NTF_BOOKING_UPDATED" ||
			ntf.type === "NTF_PROGRESS_REVIEWED" ||
			ntf.type === "NTF_PROGRESS_COMMENTS"
		);
	};

	React.useEffect(() => {
		loadNotifications();
	}, [location.pathname]);

	return (
		<HomeLayoutViewContext.Provider
			value={{
				classes,
				user,
				timeoutOpen,
				emails,
				addresses,
				usefulLinks,
				sitemaps,
				logoLink,
				contactEmail,
				location,
				openQrCode,
				navRef,
				isFixed,
				notificationAnchorEl,
				setOpenQrCode,
				setNotificationAnchorEl,
				getUserEmail,
				promptLogout,
				onSessionExtend,
				closeSessionExtend,
				closeTimeout,
				doLogout,
				getExpTime,
				lastLoginTime,
				goTop,
				clickMenu,
				clickNotification,
				notifications,
				handlePinned,
				notificationRedirect,
				handleDeleteNotification,
				loadNotifications,
				showNtfRedirect,
				showNtfClose,
				onlyOnPCDialog,
				setOnlyOnPCDialog,
			}}
		>
			<RenderPcOrMobile pc={<HomeLayoutPC {...props} />} mobile={<HomeLayoutMobile {...props} />} />
		</HomeLayoutViewContext.Provider>
	);
}

export default HomeLayout;
